import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, Form, Input, Row, Col, Spinner } from "reactstrap";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import prazoresponsividade_api from "../../../api/prazoresponsividade_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function PenalidadeFicha() {

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [isDisable, set_isDisable] = useState(true);

    const [options_prazoResponsividade, set_options_prazoResponsividade] = useState([]);

    const handleChangePrazoResponsividade = (prazoResponsividadeAnalise_Id, prazoResponsividade) => {
        let _options = [];
        options_prazoResponsividade.map(m => {
            if (m.prazoResponsividadeAnalise_Id == prazoResponsividadeAnalise_Id)
                m.prazoResponsividade = prazoResponsividade;
            _options.push(m);
        });
        set_options_prazoResponsividade(_options);
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroPrazoResponsividade", "Editar").then((result) => { set_isDisable(!result); })
        loadForm();
    }, []);

    const loadForm = () => {
        setshowLoading(true);
        prazoresponsividade_api.getAll().then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_prazoResponsividade(result.data);
            }
        })
    }

    const onSubmit = (data) => {
        if (options_prazoResponsividade.filter(f => f.prazoResponsividade == '').length > 0) {
            showMessage("Aviso", "Preencha todos os prazos!", 'error', null);
            return;
        }

        setshowLoading(true);
        prazoresponsividade_api.put(options_prazoResponsividade).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Lista Prazos de Responsividade</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="left">Situação da Análise</StyledTableCell>
                                                    <StyledTableCell align="right">Prazo (dias)</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {options_prazoResponsividade.map((n, key) => (
                                                    <StyledTableRow key={key}>
                                                        <StyledTableCell align="left">{n.situacaoAnalise}</StyledTableCell>
                                                        <StyledTableCell align="right">
                                                            <Input className="form-control text-right"
                                                                autocomplete="off"
                                                                type="number"
                                                                name="prazoResponsividade"
                                                                step={0}
                                                                defaultValue={n.prazoResponsividade}
                                                                onBlur={(e) => handleChangePrazoResponsividade(n.prazoResponsividadeAnalise_Id, e.target.value)}
                                                                innerRef={register({ required: true })}
                                                                disabled={isDisable}
                                                            />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Col>
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    body: {
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);